import React from "react";
import validator from "validator";

const setError = (valor) => {
  return <span style={{ color: "red" }}> {valor}</span>;
};

export const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return setError("Campo requerido");
  }
};

export const email = (value) => {
  if (!validator.isEmail(value)) {
    return setError(`${value} no es un correo válido.`);
  }
};

/*export const lt = (value, props) => {
  // get the maxLength from component's props
  if (!value.toString().trim().length > props.maxLength) {
    // Return jsx
    return (
      <span className="error">
        The value exceeded {props.maxLength} symbols.
      </span>
    );
  }
};
*/

export const password = (value, props, components) => {
  if (
    components["nuevacontrasena"][0].value !==
    components["rnuevacontrasena"][0].value
  ) {
    return setError("Las contraseñas deben ser iguales");
  }
};

export const password1 = (value, props, components) => {
  if (Object.keys(components["password"][0].value).length < 6) {
    return setError("Las contraseñas deben tener almenos 6 caracteres.");
  }
};
export const nombres = (value) => {
  value = value.replace(/ /g, "");
  value = value.split(".").join("");
  if (!validator.isAlpha(value, "es-ES")) {
    return setError(`El valor tiene carateres no válidos.`);
  }
};

export const telefono = (value) => {
  if (!validator.isNumeric(value)) {
    return setError(`El valor debe ser numérico.`);
  }
  if (value.length < 7) {
    return setError(`El valor debe tener minimo 7 números`);
  }
  return "";
};

export const cedula = (value) => {
  if (!validator.isNumeric(value)) {
    return setError(`El valor debe ser numérico.`);
  }
  if (value.length < 10) {
    return setError(`El valor debe tener minimo 10 números`);
  }
  return "";
};

/**
 *
 * @param {*} value valor a validar
 * @returns Validación para comprobar si un string contiene un número
 */
export const esNumero = (value) => {
  if (typeof value != "string") return false;
  return !isNaN(value) && !isNaN(parseFloat(value));
};

/**
 * Obtiene el primer número de un string de números separados por coma.
 * @param {string} str - El string de entrada.
 * @returns {string} El primer número del string.
 */
export const getFirstNumber = (str) => {
  // Validamos si el string está vacío
  if (!str || str === "") {
    return "";
  }
  // Dividimos el string por la coma y obtenemos el primer elemento
  const first = str.split(",")[0];

  // Usamos una expresión regular para eliminar todo lo que no sea un dígito
  return first.replace(/\D/g, "");
};

export const generarParametrosUrl = (datos) => {
  const parametros = [];

  for (const clave in datos) {
    if (datos.hasOwnProperty(clave)) {
      const valor = datos[clave];
      const parametro =
        encodeURIComponent(clave) + "=" + encodeURIComponent(valor);
      parametros.push(parametro);
    }
  }

  return parametros.join("&");
};

export const obtenerColor = (index) => {
  switch (index) {
    case 0:
      return '#4EA3DE'
    case 1:
      return '#BC95E8'
    default:
      return '#001871'
      break;
  }
}


export const obtenerDatosHogar = (codigoProductoEspecial) => {
  let datosHogar = {
    ramo: "Hogar",
    codigoEspecial: "hogar",
    titulo: "Cotización de Hogar Protección Total",
    producto: "PLAN ABIERTO",
    codigo: null
  };

  switch (codigoProductoEspecial) {
    case "advance":
      datosHogar.ramo = "Hogar Advance";
      datosHogar.codigoEspecial = "hogar-advance";
      datosHogar.titulo = "Cotización de Hogar Advance";
      datosHogar.producto = "HOGAR ADVANCE";
      datosHogar.codigo = codigoProductoEspecial

      break;

    case "hogar-aig":
      datosHogar.ramo = "Hogar";
      datosHogar.codigoEspecial = "hogar";
      datosHogar.titulo = "Cotización de Hogar AIG";
      datosHogar.producto = "HOGAR AIG";
      datosHogar.codigo = codigoProductoEspecial
      break;

    default:
      break;
  }

  return datosHogar;
};
